import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';

interface foodMenu {
    category: ReactNode;
    dietType: ReactNode;
    baseRate: ReactNode;
    foodId: unknown;
    price: any;
    foodCategoryName: ReactNode;
    name: string | undefined;
    dietTypeId: string;
    dietTypeName: any;
    imageUrl: any;
    menuDescription: any;
    menuTitle: any;
    data: foodMenu
    id: number;
    spiceLevelName: string;
    cookProfileId: number | string
    priceRangeFrom: number;
    priceRangeTo: number;
}
interface FoodMenuBasicIngredient {
    id: number;
    isActive: boolean;
    foodMenuId: number | string;
    auditTrailId: string | null;
    ingredientId: number;
    ingredientName: string;
}

interface foodMenuPoll {
    areaCode: any;
    menuTitle: any;
    customers: {};

}
interface foodMenuState {
    data: foodMenu[];
    cook: foodMenu[];
    basicIngredient: FoodMenuBasicIngredient[]; // ✅ Add proper type
    foodMenuPoll: foodMenuPoll[];
    loading: boolean;
    error: string | null;
}
interface FoodMenuPriceRange {
    id: string;
    foodMenuId: string;
    foodMenuName: string;
    priceRangeFrom: number;
    priceRangeTo: number;
    isActive: boolean;
    auditTrailId: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

const CUSTOMERPORT = import.meta.env.VITE_CUSTOMER_PORT;
const CUSTOMERURL = import.meta.env.VITE_API_CUSTOMER_URL;

export const fetchfoodMenu = createAsyncThunk<foodMenu[], void, { rejectValue: string }>(
    'foodMenu/fetchfoodMenu',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: foodMenu[] }>('/get_all_food_menu', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const fetchCookFoodmenu = createAsyncThunk<
    foodMenu[],
    { cookProfileId: number | string },
    { rejectValue: string }
>(
    "cookFoodMenu/fetchCookFoodmenu",
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<{ data: foodMenu[] }>(
                '/get_all_food_menu', PORT, MASTERURL, config
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

export const createfoodMenu = createAsyncThunk<foodMenu, any, { rejectValue: string }>(
    'foodMenu/createfoodMenu',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: foodMenu }>('create_food_menu', params, PORT, MASTERURL);
            return response.data[0];
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const createfoodMenuBasicIngredients = createAsyncThunk<foodMenu, any, { rejectValue: string }>(
    'foodMenu/createfoodMenu',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: foodMenu }>('create_food_menu_basic_ingredient', params, PORT, MASTERURL);
            return response.data
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);



export const softDelectFoodMenuBasicIngredients: any = createAsyncThunk<
    number,
    number
>(
    "FoodMenuBasicIngredients/softDelectFoodMenuBasicIngredients",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_food_menu_basic_ingredient?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const updatefoodMenu = createAsyncThunk<foodMenu, any, { rejectValue: string }>(
    'foodMenu/updatefoodMenu',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: foodMenu }>('update_food_menu', params, PORT, MASTERURL);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const updatefoodMenuIngredient = createAsyncThunk<foodMenu, any, { rejectValue: string }>(
    'foodMenu/updatefoodMenuIngredient',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: foodMenu }>('update_food_menu_basic_ingredient', params, PORT, MASTERURL);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateFoodMenuPriceRange = createAsyncThunk<
    FoodMenuPriceRange, // Return type
    any, // Argument type
    { rejectValue: string }
>(
    'foodMenu/updateFoodMenuPriceRange',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: FoodMenuPriceRange }>(
                'update_food_menu_price_range',
                params,
                PORT,
                MASTERURL
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error?.message || 'An error occurred');
        }
    }
);


export const getByIdfoodMenuBasicIngredients = createAsyncThunk<
    any,
    { foodMenuId: string | number },
    { rejectValue: string }
>(
    "FoodMenu/getByIdfoodMenuBasicIngredients",
    async ({ foodMenuId }, { rejectWithValue }) => {
        try {
            const config = { params: { foodMenuId } };

            const response = await apiService.get<FoodMenuBasicIngredient>(
                `get_by_id_food_menu_basic_ingredient`,
                PORT,
                MASTERURL,
                config
            );
            return response;
        } catch (error: any) {
            return rejectWithValue(error?.message || 'Failed to fetch food menu ingredients');
        }
    }
);



export const softDeleteFoodMenu: any = createAsyncThunk<
    number,
    number
>(
    "FoodMenu/softDeleteFoodMenu",
    async (id) => {
        try {
            const response = await apiService.patch(
                `soft_delete_food_menu?id=${id}`,
                {},
                PORT,
                MASTERURL
            );
            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);




export const basicIngredientFoodMenu = createAsyncThunk<
    FoodMenuBasicIngredient[],
    { foodMenuId: number | string },
    { rejectValue: string }
>(
    "FoodMenu/basicIngredientFoodMenu",
    async (params, { rejectWithValue }) => {
        try {
            // Build axios config with params
            const config = { params };

            const response = await apiService.get<{ data: any }>(
                '/get_basic_ingredient_by_food_menu_id', PORT, MASTERURL, config
            );

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);


export const fetchFoodmenuPoll = createAsyncThunk<
    foodMenuPoll[],
    { areaCodeId?: any },
    { rejectValue: string }
>(
    "FoodMenu/fetchFoodmenuPoll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: foodMenuPoll[] }>(
                "/get_all_menu_poll",
                params,
                CUSTOMERPORT,
                CUSTOMERURL
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

export const foodMenuSlice = createSlice({
    name: 'foodMenu',
    initialState: {
        data: [],
        cook: [],
        basicIngredient: [],
        foodMenuPoll: [],
        loading: false,
        error: null,
    } as foodMenuState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchfoodMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchfoodMenu.fulfilled, (state, action: PayloadAction<foodMenu[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchfoodMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

            .addCase(fetchCookFoodmenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCookFoodmenu.fulfilled, (state, action: PayloadAction<foodMenu[]>) => {
                state.loading = false;
                state.cook = action.payload;
            })
            .addCase(fetchCookFoodmenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

            .addCase(createfoodMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createfoodMenu.fulfilled, (state, action: PayloadAction<foodMenu>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createfoodMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updatefoodMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatefoodMenu.fulfilled, (state, action: PayloadAction<foodMenu>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updatefoodMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(basicIngredientFoodMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(basicIngredientFoodMenu.fulfilled, (state, action: PayloadAction<FoodMenuBasicIngredient[]>) => {
                state.loading = false;
                state.basicIngredient = action.payload;
            })

            .addCase(basicIngredientFoodMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(fetchFoodmenuPoll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFoodmenuPoll.fulfilled, (state, action: PayloadAction<foodMenuPoll[]>) => {
                state.loading = false;
                state.foodMenuPoll = action.payload;
            })
            .addCase(fetchFoodmenuPoll.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default foodMenuSlice.reducer;